module.exports = __webpack_public_path__ + "images/978c16485a985f95d6460342478c443d.png";